import api from './api';

const chatService = {
  getUnreadCount: async (userId) => {
    const response = await api.get(`/chat/unread-count/${userId}`);
    return response.data;
  },

  getNotifications: async (userId, unreadOnly = false) => {
    const response = await api.get(`/chat/notifications/${userId}`, {
      params: unreadOnly ? { unread: 1 } : undefined,
    });
    return response.data;
  },

  markAllNotificationsRead: async (userId) => {
    const response = await api.patch('/chat/notifications/read-all', { userId });
    return response.data;
  },

  getPatientLatestVitals: async (practiceId, patientUserId) => {
    const response = await api.get(
      `/chat/patient-vitals/${practiceId}/${patientUserId}`
    );
    return response.data;
  },

  deleteMessage: async (messageId, userId, mode = 'me') => {
    const response = await api.delete(`/chat/delete/${messageId}`, {
      data: { userId, mode },
    });
    return response.data;
  },

  editMessage: async (messageId, userId, newMessage) => {
    const response = await api.put(`/chat/edit/${messageId}`, {
      userId,
      newMessage,
    });
    return response.data;
  },

  deleteConversations: async (userId, otherUserIds) => {
    const response = await api.post('/chat/conversations/delete', {
      userId,
      otherUserIds,
    });
    return response.data;
  },

  getChatSummary: async (userId1, userId2, { startDate, endDate, requesterUserId }) => {
    const response = await api.get(`/chat/summary/${userId1}/${userId2}`, {
      params: {
        startDate,
        endDate,
        userId: requesterUserId,
      },
    });
    return response.data;
  },
};

export default chatService;

export const CHAT_MESSAGE_EVENT = 'evitals:chat-message';
export const CHAT_UNREAD_REFRESH_EVENT = 'evitals:chat-unread-refresh';

export function dispatchChatMessageEvent(message) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CHAT_MESSAGE_EVENT, { detail: message }));
}

export function dispatchChatUnreadRefresh() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CHAT_UNREAD_REFRESH_EVENT));
}
